import type { MemberPackageKey } from "@/utils/memberTier";

/** 已购试用档位值，数值越小等级越高。与 getRights.trialTier 一致。 */
export const TRIAL_QUEUE_PREFIX = {
  vip: 80,
  svip: 70,
  ultra: 60
} as const;

export const TRIAL_TIER_LABEL = {
  vip: "标准版",
  svip: "专业版",
  ultra: "旗舰版"
} as const;

/** 升级试用按钮与矩阵升级文案对齐的 PRD 短名 */
export const TRIAL_VERSION_SHORT = {
  vip: "VIP",
  svip: "SVIP",
  ultra: "VVIP"
} as const;

/** 卡片展示价。实付仍以预下单 totalAmount 为准。 */
export const TRIAL_DISPLAY_SKU = {
  vip: { priceYuan: 19.9, priceFen: 1990, credits: 900 },
  svip: { priceYuan: 29.9, priceFen: 2990, credits: 1700 },
  ultra: { priceYuan: 39.9, priceFen: 3990, credits: 2500 }
} as const;

/** 试用结束按月续费后的每月算力（与完整版月付一致） */
export const TRIAL_RENEW_MONTHLY_CREDITS = {
  vip: 3000,
  svip: 9000,
  ultra: 20000
} as const;

/** 试用卡片权益列表顶部两行（产品「会员生图权益文案」低价试用版），替换完整版的月度整句 */
export const TRIAL_HEADLINE_RIGHTS = {
  vip: ["约生成 900 张图/7天，大幅提升原画效率", "全球旗舰生图模型，可生成约180张图"],
  svip: ["约生成 1700 张图/7天，大幅提升原画效率", "全球旗舰生图模型，可生成约340张图"],
  ultra: ["约生成 2500 张图/7天，大幅提升原画效率", "全球旗舰生图模型，可生成约500张图"]
} as const;

/** 试用购买详情中的连续包周期文案（仅 subscribe / halfSubscribe 可试用） */
export const TRIAL_CYCLE_LABEL = {
  subscribe: "连续包月",
  halfSubscribe: "连续包半月"
} as const;

export const TRIAL_FULL_HINT = {
  vip: "8.8折享3000算力/月",
  svip: "8.8折享9000算力/月",
  ultra: "7.9折享20000算力/月"
} as const;

export const TRIAL_RENEW_HINT = {
  vip: "试用后按月续费，发放3000算力/月",
  svip: "试用后按月续费，发放9000算力/月",
  ultra: "试用后按月续费，发放20000算力/月"
} as const;

export const TRIAL_UNAVAILABLE_MESSAGE = "试用资格已失效，请改选畅享完整版后重新支付";

export const TRIAL_AMOUNT_MISMATCH_MESSAGE = "试用展示价与实付金额不一致，将按实付金额支付";

/** 已购/正在试用本档：按钮与脚注（对齐原型 owned） */
export const TRIAL_ACTIVE_SAME_TIER_BUTTON = "您已享受试用";
export const TRIAL_ACTIVE_SAME_TIER_FOOTNOTE = "您还可购买更高等级试用";

/** 低于已购试用最高档：按钮与脚注（对齐原型 lower） */
export const TRIAL_LOWER_BLOCKED_BUTTON = "已享受更高等级试用";
export const TRIAL_LOWER_BLOCKED_FOOTNOTE = "已购更高等级试用，不可再购本档";

export type PaidMemberPackageKey = Exclude<MemberPackageKey, "free">;

export type TrialOfferKind = "trial" | "full";

export function isPaidMemberPackage(key: string): key is PaidMemberPackageKey {
  return key === "vip" || key === "svip" || key === "ultra";
}

export function trialHint(key: PaidMemberPackageKey): string {
  const sku = TRIAL_DISPLAY_SKU[key];
  return `${sku.priceYuan}元享7天${sku.credits}算力`;
}
